import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

// Redux type and action creators
const { Types, Creators } = createActions({
  objectSelected: ['object'],
  objectDeselected: ['object'],
  objectsSelected: ['objects'],
  objectsDeselected: ['objects'],
  objectToggled: ['object'],
  featuresSelected: ['features'],
  multiselectToggled: [],
  uuidsHighlighted: ['uuids'],
  reset: []
})

export const ObjectTypes = Types
export default Creators

// Initial state
export const INITIAL_STATE = Immutable({
  uuidsSelected: [],
  uuidsHighlighted: [],
  objectsSelected: {},
  featuresSelected: [],
  multiselect: false
})

// Redux reducers
export const objectSelected = (state, { layerName, object }) => {
  console.log(layerName, object)
  return state
}

export const objectDeselected = (state, { object }) => {
  console.log(object)
  return state
}

export const objectToggled = (state, { object }) => {
  const { uuid } = object

  if (!uuid) {
    return state
  }

  if (state.uuidsSelected.includes(uuid)) {
    const uuidsSelected = state.uuidsSelected.filter(item => item !== uuid)
    return state.merge({ uuidsSelected })
  } else {
    const uuidsSelected = state.multiselectToggled
      ? state.uuidsSelected.concat(uuid)
      : [uuid]
    return state.merge({ uuidsSelected })
  }
}

export const objectsSelected = (state, { objects }) => {
  if (!objects) {
    return state.merge({ uuidsSelected: [] })
  }

  const uuidsSelected = objects.map(object => object.uuid)
  return state.merge({ uuidsSelected })
}

export const objectsDeselected = (state, { objects }) => {
  if (!objects) {
    return state.merge({ uuidsSelected: [] })
  }

  // const uuidsDeselected = objects.map(object => object.uuid)
  // const uuidsSelected = state.uuidsSelected.filter(
  //   item => !uuidsDeselected.includes(item.uuid)
  // )

  return state.merge({ uuidsSelected: [] })
}

export const featuresSelected = (state, { features }) => {
  if (!features) {
    return state
  }

  return state.merge({ featuresSelected: features })
}

export const uuidsHighlighted = (state, { uuids }) => {
  if (!uuids) {
    return state.merge({ uuidsHighlighted: [] })
  }

  return state.merge({ uuidsHighlighted: uuids })
}

export const multiselectToggled = state => {
  return state.merge({ multiselectToggled: !state.multiselectToggled })
}

export const objectReset = state => {
  return INITIAL_STATE
}

// Assign types to reducers
export const reducer = createReducer(INITIAL_STATE, {
  [Types.OBJECT_SELECTED]: objectSelected,
  [Types.OBJECT_DESELECTED]: objectDeselected,
  [Types.OBJECTS_SELECTED]: objectsSelected,
  [Types.OBJECTS_DESELECTED]: objectsDeselected,
  [Types.OBJECT_TOGGLED]: objectToggled,
  [Types.FEATURES_SELECTED]: featuresSelected,
  [Types.MULTISELECT_TOGGLED]: multiselectToggled,
  [Types.UUIDS_HIGHLIGHTED]: uuidsHighlighted,
  [Types.RESET]: objectReset
})



// WEBPACK FOOTER //
// ./src/redux/objectRedux.js